import styles from '@/features/common/components/Overview/parts/ProductItem/styles'
import { TextSize } from '@/features/common/components/Overview/parts/ProductItem/types'
import Typography from '@/features/ui/typography'
import { FC } from 'react'

interface NameProps {
    children: string
    textSize: TextSize
}

const Name: FC<NameProps> = ({ children, textSize }) => {
    return (
        <Typography.Description size={textSize} font="regular" style={styles.optionName}>
            {children}
        </Typography.Description>
    )
}

export default Name
